import Model from '@/models/Model'

export default class PchProvider extends Model {
    resource() {
        return 'pch_provider'
    }
}